'use strict';

angular.module('substoreApp.controllers')
    .controller('orderselectionController', OrderselectionController);

function OrderselectionController($scope, $window, dialogData, uiservice, sessionData, productDataCollector, htmlTruster, webtrekk, $log) {

    $scope.isCatalogueActive = true;

    $scope.progressBar.reset();

    $scope.confirmation = {
        // this might get used by some partner features
        requestedParameterValue: null,
        // fields to be provided for oform directive
        createCustomerOrderForm: false,
        customerSignatureObtained: false,
        customerEmail: ""
    };

    function initDialogData() {
        var data = $scope.data = dialogData;
        var product = productDataCollector.collect(data.product);

        sessionData.transient.orderCallId = data.orderCallId;

        if (data.subscriptionBookedByExtern) {
            $scope.isCatalogueActive = false;
            $scope.isMyProductsActive = true;
        }

        htmlTruster.trust($scope.data.product);

        $scope.data.dataTransferAccepted = true;

        $scope.footnotes = product.productDescription.footnotes;

        $scope.confirmation.customerEmail = data.customerEmail;

        $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderselection', 'dialog' ]);

        if (data.orderSelectionSkipped) {
            $scope.next();
            return;
        }

        $scope.breadcrumb.init(
            data.subscriptionBookedByExtern ? "navigation_myproducts" : "navigation_catalogue",
            data.subscriptionBookedByExtern ? "#/myproducts": "#/");
        $scope.breadcrumb.add(product.texts.productName, "#/productdetails/" + (product.productGroup || product.subscriptionTemplateId));
        $scope.breadcrumb.add("order");

        $scope.updateTeaser(
            product.texts.headerTitleSelection,
            product.texts.headerSubTitleSelection,
            product.images.headerImageSelectionResourcePath);

        $scope.progressBar.setup({
            step: 1,
            isOnlyReservationAllowed: data.isOnlyReservationAllowed,
            isPurchaseRedirectRequired: data.isPurchaseRedirectRequired,
            thirdPartyAuthentication: data.thirdPartyAuthentication,
            progressBarEnabled: data.progressBarEnabled
        });

        if ( data.isOnlyReservationAllowed ) {
            webtrekk.track('order_reservation', {
                shop_product_sku: product.subscriptionTemplateId
            });
        } else {
            webtrekk.track('order_selection', {
                shop_product_name: product.texts.productName,
                shop_product_quantity: "1",
                shop_product_sku: product.subscriptionTemplateId,
                shop_product_status: "add"
            });
        }
    }

    // configure routing dialog functions

    $scope.nextClicked = false;

    $scope.next = function () {
        if ($scope.nextClicked)
            return;
        var valid = $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderselection', 'validation' ]);
        if (valid) {
            $scope.nextClicked = true;

            uiservice.subscriptionBegin({
                    sessionId: sessionData.sessionId,
                    orderCallId: sessionData.transient.orderCallId,
                    subscriptionTemplateId: $scope.data.product.subscriptionTemplateId,
                    dataTransferAccepted: $scope.data.dataTransferAccepted,
                    requestedParameter: $scope.confirmation.requestedParameterValue,
                    createCustomerOrderForm: $scope.confirmation.createCustomerOrderForm,
                    customerSignatureObtained: $scope.confirmation.customerSignatureObtained,
                    customerEmail: $scope.confirmation.customerEmail},
                function success(response) {
                    var shouldProceed = $scope.applyFeature($scope, [ $scope.data.partnerName, 'orderselection', 'next' ]);
                    if (shouldProceed) {
                        if (response.data.reserved) {
                            $scope.go("/reservationconfirmation/" + $scope.data.product.subscriptionTemplateId);
                        } else {
                            if (($scope.data.subscriptionBookedByExtern || response.data.redirectRequired) && response.data.authenticationURL) {

                                /*webtrekk.track('order_registration', {
                                    shop_product_name: $scope.data.product.texts.productName,
                                    shop_product_quantity: "1",
                                    shop_product_sku: $scope.data.product.subscriptionTemplateId
                                }).promise.then(function() {
                                    $window.location.href = response.data.authenticationURL;
                                });*/
                                $window.location.href = response.data.authenticationURL;

                            } else {
                                // either we don't need to authenticate at a 3rd party site, or we already have done it
                                $scope.go("/ordersummary/" + $scope.data.product.subscriptionTemplateId + "/" + sessionData.transient.orderCallId);
                            }
                        }
                    }
                },
                $scope.throwServiceResponseFault
            );
        }
    };

    initDialogData();
}